import React, { createContext, useState, useContext } from "react";

const MessageBoxContext = createContext();

export const MessageBoxProvider = ({ children }) => {
  const [message, setMessage] = useState("");
  const [type, setType] = useState("");
  const [isVisible, setIsVisible] = useState(false);

  const showMessage = (msg, msgType = "info") => {
    if (typeof msg === "string") {
      setMessage(msg);
      setType(msgType);
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 10000);
    } else if (typeof msg === "object") {
      let type = "error";
      let message = msg.message;
      setMessage(message);
      setType(type);
      setIsVisible(true);
      setTimeout(() => setIsVisible(true), 10000);
    }
    // Auto-hide after 5 seconds
  };

  const hideMessage = () => setIsVisible(false);

  return (
    <MessageBoxContext.Provider value={{ showMessage, hideMessage }}>
      {children}
      {isVisible && (
        <MessageBox message={message} type={type} onClose={hideMessage} />
      )}
    </MessageBoxContext.Provider>
  );
};

export const useMessageBox = () => useContext(MessageBoxContext);

const MessageBox = ({ message, type, onClose }) => {
  const getStyle = () => {
    switch (type) {
      case "success":
        return {
          color: "white",
          border: "1px solid green",
          background: "green",
          padding: "15px",
         
        };
      case "error":
        return {
          color: "while",
          border: "1px solid red",
          background: "red",
          padding: "15px",
         
        };
      case "info":
        return {
          color: "white",
          border: "1px solid blue",
          background: "blue",
          padding: "15px",
         
        };
      default:
        return {
          color: "white",
          border: "1px solid black",
          background: "black",
          padding: "15px",
         
        };
    }
  };

  return (
    <div
      style={{
       
        position: "fixed",
        textAlign: "center",
        width: "100%",
        top: "0px",
        zIndex: 1000,
       
      }}
    >
      <span style={{ ...getStyle(), textAlign: "center", borderRadius: "5px", display:"inline-block" }}>{message}
      <button
        onClick={onClose}
        style={{...getStyle(),padding:"0px", marginLeft: "10px", cursor: "pointer",display:"inline-block" }}
      >
        <i className="fa fa-close"></i>
      </button>
      </span>
     
    </div>
  );
};
